import React from 'react'
import CConsentBanner from '@dfb/gatsby-dfb-theme/src/components/elements/c_consent_banner'

const CMediaVideo = ({ video_embed_id, video_autoplay = 0, className = '' }) => {
  const autoplay = video_autoplay && video_autoplay === 1 ? true : false

  return (
    <div className={`c-Media${className ? ' ' + className : ''}`}>
      {video_embed_id && (
        <CConsentBanner serviceName="YouTube Video">
          <div className="c-Media-embed">
            <iframe
              title="Video"
              src={
                'https://www.youtube-nocookie.com/embed/' +
                video_embed_id +
                (autoplay ? (video_embed_id.indexOf('?') !== -1 ? '&' : '?') + 'autoplay=1&mute=1' : '')
              }
              allow="autoplay; encrypted-media"
              allowFullScreen
            ></iframe>
          </div>
        </CConsentBanner>
      )}
    </div>
  )
}

export default CMediaVideo
